import { render, staticRenderFns } from "./user_index.vue?vue&type=template&id=83b7bb56&scoped=true&"
import script from "./user_index.vue?vue&type=script&lang=js&"
export * from "./user_index.vue?vue&type=script&lang=js&"
import style0 from "./user_index.vue?vue&type=style&index=0&id=83b7bb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b7bb56",
  null
  
)

export default component.exports